import { Link } from "react-router-dom";
import { Crown, ArrowRight, Gift } from "lucide-react";
import { isFreePeriod } from "@/lib/pricing";

function Inner() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 h-11 flex items-center justify-center gap-2 text-sm font-bold">
      <Crown className="w-4 h-4 shrink-0" />
      <span className="text-center">
        <span className="hidden sm:inline">Nieuwe klant? </span>Probeer Pro je <span className="underline decoration-2 underline-offset-2">eerste kwartaal voor maar €1</span>
      </span>
      <ArrowRight className="w-4 h-4 shrink-0 group-hover:translate-x-1 transition-transform" />
    </div>
  );
}

export function PromoBar({ to, onClick }) {
  if (isFreePeriod()) {
    return (
      <div data-testid="promo-bar" className="block w-full bg-green-600 text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-11 flex items-center justify-center gap-2 text-sm font-bold">
          <Gift className="w-4 h-4 shrink-0" />
          <span className="text-center">Gratis voor iedereen tot 31 december 2026 — geen abonnement nodig</span>
        </div>
      </div>
    );
  }
  const cls = "group block w-full bg-orange-500 hover:bg-orange-600 transition-colors text-white";
  if (to) {
    return <Link to={to} data-testid="promo-bar" className={cls}><Inner /></Link>;
  }
  return <button type="button" data-testid="promo-bar" onClick={onClick} className={cls}><Inner /></button>;
}
